import { render, staticRenderFns } from "./OffGridComponent.vue?vue&type=template&id=613c936e&"
import script from "./OffGridComponent.vue?vue&type=script&lang=js&"
export * from "./OffGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports